<template>  
    <b-card class="talent-card">
        <b-row>
            <b-col md="5">
                <h4 class="mb-0">{{talent.persona}}</h4>
                <b-badge>{{(talent.gender === 'male' ? 'Male' : 'Female')}}</b-badge>
            </b-col>

            <b-col md="7">
                <audio-player v-if="sample" class="mb-4"
                    :url="sample.path" 
                    :index="sample.uuid" 
                    :name="sample.name"
                    v-on:playing="playing"
                    :base_url="baseUrl"
                ></audio-player>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="5">
                <ul class="mb-0 pl-0 pricing">
                    <li><strong>Session Fee: </strong>${{pricing.record_fee.toFixed(2)}} <font-awesome-icon v-if="pricing.record_fee_threshold" :id="'recordFeeHlep' + talent.id" icon="question-circle" /></li>
                    <b-popover :id="'record-fee-help-' + talent.id" v-if="pricing.record_fee_threshold" title="Record Fee" :target="'recordFeeHlep' + talent.id" placement="bottomleft" triggers="hover" :content="''">
                        <template slot="default">
                            <p>Session fee is waived with an order of {{pricing.record_fee_threshold}} or more prompts.</p>
                        </template>
                    </b-popover>
                    <li v-if="pricing.type == 'prompt'"><strong>Price: </strong>${{pricing.price_per_prompt.toFixed(2)}} / Prompt</li>
                    <li v-if="pricing.type == 'prompt' && pricing.extra_words_price"><strong>Overage Fee: </strong>${{pricing.extra_words_price.toFixed(2)}}  / Word <font-awesome-icon  :id="'extraWordsHelp' + talent.id" icon="question-circle" /></li>
                    <b-popover :id="'extra-words-help-' + talent.id" title="Overage Fee" :target="'extraWordsHelp' + talent.id" placement="bottomleft" triggers="hover" :content="''">
                        <template slot="default">
                            <p>Each additional word over {{pricing.words_included}} is ${{pricing.extra_words_price}}</p>
                        </template>
                    </b-popover>
                </ul>
            </b-col>

            <b-col md="7" class="text-right mt-auto">
                <b-button variant="primary" @click="select">Select Talent</b-button>
            </b-col>
        </b-row>


        <b-row v-if="false">
            <b-col sm="6">
                <ul class="mb-0 pl-0 pricing">
                    <li><strong>Session Fee: </strong>${{pricing.record_fee.toFixed(2)}} <font-awesome-icon v-if="pricing.record_fee_threshold" id="recordFeeHlep" icon="question-circle" /></li>
                    <b-popover id="record-fee-help" v-if="pricing.record_fee_threshold" title="Record Fee" :target="'recordFeeHlep'" placement="bottomleft" triggers="hover" :content="''">
                        <template slot="default">
                            <p>Session fee is waived with an order of {{pricing.record_fee_threshold}} or more prompts.</p>
                        </template>
                    </b-popover>
                    <li v-if="pricing.type == 'prompt'"><strong>Price: </strong>${{pricing.price_per_prompt.toFixed(2)}} / Prompt</li>
                    <li v-if="pricing.type == 'prompt' && prcing.extra_words_price"><strong>Overage Fee: </strong>${{pricing.extra_words_price.toFixed(2)}}  / Word <font-awesome-icon  :id="'extraWordsHelp' + talent.id" icon="question-circle" /></li>
                    <b-popover :id="'extra-words-help' + talent.id" title="Overage Fee" :target="'extraWordsHelp'" placement="bottomleft" triggers="hover" :content="''">
                        <template slot="default">
                            <p>Each additional word over {{pricing.words_included}} is ${{pricing.extra_words_price}}</p>
                        </template>
                    </b-popover>
                </ul>
            </b-col>
            <b-col sm="6" class="text-right mt-auto">
                <b-button variant="primary">Select Talent</b-button>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
    import AudioPlayer from './AudioPlayer'
    import {mapState} from 'vuex'
    export default {
        components: {AudioPlayer},
        props: ['talent'],
        data() {
            return {
                playerPlaying: null,
                baseUrl: 'https://' + process.env.PROMPTS_URL + '/samples/'
            };
        },
        methods: {
            playing: function(playerId, sample_id) {
                this.playerPlaying = playerId;
            },
            select () {
                this.$emit('TalentPicked', this.talent)
            }
        },
        computed: {
            ...mapState({
                application: state => state.project.application,
                defaultPricing: state => state.pricing
            }),
            pricing () {
                if (!this.application) {
                    return this.defaultPricing
                }

                if (this.talent.pricing.length === 0) {
                    return this.defaultPricing
                }
                
                let appPricing = this.talent.pricing.find(app => app.id == this.application.id)

                if (!appPricing) {
                    return this.defaultPricing
                }
                
                return {
                    words_included: appPricing.pivot.words_included,
                    price_per_prompt: parseFloat(appPricing.pivot.price),
                    extra_words_price: parseFloat(appPricing.pivot.overage_price),
                    record_fee: parseFloat(appPricing.pivot.record_fee),
                    type: appPricing.pivot.frequency,
                    record_fee_threshold: appPricing.pivot.record_fee_threshold
                }
            },
            samples () {

                return this.talent.samples.filter(sample => {
                    if (!this.application) {
                        return true
                    }

                    let tags = sample.tags.filter(tag => tag.id === this.application.id)
                    return tags.length
                });
            },
            sample () {
                if (this.samples && this.samples.length === 0) {
                    return null
                }

                return this.samples[0]
            }
        },
        created() {
            
        },
        mounted () {
            
        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/TalentCard.vue